import { Button, Page } from '@rammetec/design-system'
import { useNavigate } from 'react-router-dom'

export interface ForbiddenPageProps {
  slug?: string
}

export function ForbiddenPage({ slug }: ForbiddenPageProps) {
  const navigate = useNavigate()
  return (
    <Page
      name="console.forbidden"
      title="Sem acesso"
      description={slug ? `Você não tem acesso ao módulo "${slug}".` : 'O recurso solicitado não está disponível para você.'}
      actions={<Button onClick={() => navigate('/')}>Voltar</Button>}
    />
  )
}
